import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { createCustomer } from '../customers'

export default function useCustomerCreate() {
  const queryClient = useQueryClient()

  const { mutateAsync, mutate, isLoading, isSuccess } = useMutation(
    createCustomer,
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customer')
        notification.success({
          message: 'Sucesso!',
          description: 'Cadastro realizado com sucesso'
        })
      },
      onError: () => {
        notification.error({
          message: 'Erro',
          description: 'Não foi possível completar o cadastro!'
        })
      }
    }
  )

  return { mutateAsync, mutate, isLoading, isSuccess }
}
